import {
    buscarUsuarioConsultaAcesso,
    buscarClienteConsultaAcesso,
    buscarClienteConsultaAcessoSenhaAmbiente,
    getPermissoesConsultaAcesso,
    listarFavoritosConsultaAcesso,
    adicionarFavoritoConsultaAcesso,
    removerFavoritoConsultaAcesso,
    removerTodosFavoritosConsultaAcesso,
    listarDepartamentos,
    listarGruposConsultaAcesso,
  } from '~/Services/Service';
  import AuthStorage from '~/Utils/AuthStorage';
  import {
    FETCHING_CONSULTA_ACESSO_PERMISSOES,
    FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS,
    FETCH_CONSULTA_ACESSO_PERMISSOES_ERROR,
    CONSULTA_ACESSO_SET_MODE,
    CONSULTA_ACESSO_SET_SEARCH_TERM,
    FETCHING_CONSULTA_ACESSO,
    FETCH_CONSULTA_ACESSO_SUCCESS,
    FETCH_CONSULTA_ACESSO_ERROR,
    CONSULTA_ACESSO_SELECT_RESULT,
    CONSULTA_ACESSO_CLEAR,
    FETCHING_CONSULTA_ACESSO_FAVORITOS,
    FETCH_CONSULTA_ACESSO_FAVORITOS_SUCCESS,
    FETCH_CONSULTA_ACESSO_FAVORITOS_ERROR,
    CONSULTA_ACESSO_ADD_FAVORITO,
    CONSULTA_ACESSO_REMOVE_FAVORITO,
    CONSULTA_ACESSO_REMOVE_TODOS_FAVORITOS,
    FETCH_CONSULTA_ACESSO_DEPARTAMENTOS_SUCCESS,
    FETCH_CONSULTA_ACESSO_GRUPOS_SUCCESS,
    CONSULTA_ACESSO_SET_FILTRO_DEPARTAMENTO,
    CONSULTA_ACESSO_SET_FILTRO_GRUPO,
    CONSULTA_ACESSO_SET_MODO_BUSCA,
    CONSULTA_ACESSO_SET_INCLUIR_INATIVOS,
  } from './reducer';

  export const carregarPermissoes = () => async dispatch => {
    dispatch({ type: FETCHING_CONSULTA_ACESSO_PERMISSOES });
    try {
      const permissoes = await getPermissoesConsultaAcesso();
      const podeVerSenhaClienteAmbiente = AuthStorage.temCaracteristicas([656]);
      const temAcessoCompletoCA = AuthStorage.temCaracteristicas([389, 595, 596, 611]);
      const apenasClientes = podeVerSenhaClienteAmbiente && !temAcessoCompletoCA;
      dispatch({
        type: FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS,
        payload: {
          ...permissoes,
          pode_ver_clientes: permissoes.pode_ver_clientes || podeVerSenhaClienteAmbiente,
          pode_ver_senha_cliente_ambiente: podeVerSenhaClienteAmbiente,
          apenas_clientes: apenasClientes,
        },
      });
      if (apenasClientes) {
        dispatch({ type: CONSULTA_ACESSO_SET_MODE, payload: false });
      }
    } catch (err) {
      dispatch({ type: FETCH_CONSULTA_ACESSO_PERMISSOES_ERROR, payload: err });
    }
  };

  export const setMode = (isUser) => ({
    type: CONSULTA_ACESSO_SET_MODE,
    payload: isUser,
  });

  export const setSearchTerm = (termo) => ({
    type: CONSULTA_ACESSO_SET_SEARCH_TERM,
    payload: termo,
  });

  export const carregarFiltros = () => async dispatch => {
    // Filtros de departamento/grupo só existem no modo busca por usuário.
    // Quem só tem a 656 (SenhaClienteAmbiente) é forçado para o modo cliente e
    // não precisa carregar filtros administrativos.
    // Sem este guard o 403 cai no interceptor global e desloga o usuário.
    const temAcessoCompletoCA = AuthStorage.temCaracteristicas([389, 595, 596, 611]);
    if (!temAcessoCompletoCA) return;
    try {
      const [departamentos, grupos] = await Promise.all([
        listarDepartamentos(),
        listarGruposConsultaAcesso(),
      ]);
      dispatch({ type: FETCH_CONSULTA_ACESSO_DEPARTAMENTOS_SUCCESS, payload: departamentos });
      dispatch({ type: FETCH_CONSULTA_ACESSO_GRUPOS_SUCCESS, payload: grupos || [] });
    } catch (_) {}
  };

  export const setFiltroDepartamento = (option) => ({
    type: CONSULTA_ACESSO_SET_FILTRO_DEPARTAMENTO,
    payload: option,
  });

  export const setFiltroGrupo = (option) => ({
    type: CONSULTA_ACESSO_SET_FILTRO_GRUPO,
    payload: option,
  });

  export const setModoBusca = (modo) => ({
    type: CONSULTA_ACESSO_SET_MODO_BUSCA,
    payload: modo,
  });

  export const setIncluirInativos = (valor) => ({
    type: CONSULTA_ACESSO_SET_INCLUIR_INATIVOS,
    payload: valor,
  });

  export const buscar = () => async (dispatch, getState) => {
    const {
      isUser,
      apenasClientes,
      searchTerm,
      modoBusca,
      filtroDepartamento,
      filtroGrupo,
      incluirInativos,
    } = getState().consultaAcesso;
    const termo = searchTerm ? searchTerm.trim() : '';

    if (!isUser) {
      if (!termo) return;
      dispatch({ type: FETCHING_CONSULTA_ACESSO });
      try {
        const resultados = apenasClientes
          ? await buscarClienteConsultaAcessoSenhaAmbiente(termo)
          : await buscarClienteConsultaAcesso(termo);
        dispatch({ type: FETCH_CONSULTA_ACESSO_SUCCESS, payload: resultados });
      } catch (err) {
        dispatch({
          type: FETCH_CONSULTA_ACESSO_ERROR,
          payload: (err && err.message) || 'Erro ao buscar dados',
        });
      }
      return;
    }

    const paramTermo = termo || null;
    const paramDepto =
      modoBusca === 'departamento' && filtroDepartamento ? filtroDepartamento.value : null;
    const paramGrupo =
      modoBusca === 'grupo' && filtroGrupo ? filtroGrupo.value : null;

    if (!paramTermo && !paramDepto && !paramGrupo) return;

    dispatch({ type: FETCHING_CONSULTA_ACESSO });
    try {
      const resultados = await buscarUsuarioConsultaAcesso(paramTermo, paramDepto, paramGrupo);
      const filtrados = incluirInativos
        ? resultados
        : (resultados || []).filter(r => r.status === 0);
      dispatch({ type: FETCH_CONSULTA_ACESSO_SUCCESS, payload: filtrados });
    } catch (err) {
      dispatch({
        type: FETCH_CONSULTA_ACESSO_ERROR,
        payload: (err && err.message) || 'Erro ao buscar dados',
      });
    }
  };

  export const selecionarResultado = (resultado) => ({
    type: CONSULTA_ACESSO_SELECT_RESULT,
    payload: resultado,
  });

  export const limpar = () => ({
    type: CONSULTA_ACESSO_CLEAR,
  });

  export const listarFavoritos = () => async dispatch => {
    dispatch({ type: FETCHING_CONSULTA_ACESSO_FAVORITOS });
    try {
      const favoritos = await listarFavoritosConsultaAcesso();
      dispatch({ type: FETCH_CONSULTA_ACESSO_FAVORITOS_SUCCESS, payload: favoritos });
    } catch (err) {
      dispatch({ type: FETCH_CONSULTA_ACESSO_FAVORITOS_ERROR, payload: err });
    }
  };

  const recarregarListaFavoritos = async (dispatch) => {
    try {
      const favoritos = await listarFavoritosConsultaAcesso();
      dispatch({ type: FETCH_CONSULTA_ACESSO_FAVORITOS_SUCCESS, payload: favoritos });
    } catch (_) {}
  };

  export const toggleFavorito = (identificador, isUser, isFavorito) => async dispatch => {
    if (isFavorito) {
      dispatch({ type: CONSULTA_ACESSO_ADD_FAVORITO, payload: identificador });
      try {
        await adicionarFavoritoConsultaAcesso(identificador, isUser);
        await recarregarListaFavoritos(dispatch);
      } catch {
        dispatch({ type: CONSULTA_ACESSO_REMOVE_FAVORITO, payload: identificador });
      }
    } else {
      dispatch({ type: CONSULTA_ACESSO_REMOVE_FAVORITO, payload: identificador });
      try {
        await removerFavoritoConsultaAcesso(identificador);
      } catch {
        dispatch({ type: CONSULTA_ACESSO_ADD_FAVORITO, payload: identificador });
        await recarregarListaFavoritos(dispatch);
      }
    }
  };

  export const removerTodosFavoritos = () => async dispatch => {
    try {
      await removerTodosFavoritosConsultaAcesso();
      dispatch({ type: CONSULTA_ACESSO_REMOVE_TODOS_FAVORITOS });
    } catch { }
  };
